import { useState } from "react";

import "./styles.scss";

const IntervalSelector = ({ apply }) => {
  const [interval, setInterval] = useState({ min: 0, max: null });
  const handleChange = (e) => {
    const value = e.target.value !== "" ? parseInt(e.target.value) : "";
    setInterval((interval) => ({ ...interval, [e.target.name]: value }));
  };

  return (
    <div className="intervalSelector">
      <div className="inputs">
        <div className="min">
          <input
            type="text"
            name="min"
            onChange={handleChange}
            value={interval.min ?? ""}
            placeholder="Min"
          />
        </div>
        <div className="max">
          <input
            type="text"
            name="max"
            onChange={handleChange}
            value={interval.max ?? ""}
            placeholder="Max"
          />
        </div>
      </div>
      <div>
        <span className="applyLink" onClick={() => apply(interval)}>
          Aplicar
        </span>
      </div>
    </div>
  );
};

export default IntervalSelector;
